<template>
  <Requirements @nextClick="toNext" />
</template>

<script>
  export default {
    name: 'IndividualA',
    pRouter: 'ChooseMerchantType',
    data() {
      return {
      }
    },
    methods: {

    }
  }
</script>


<style lang="scss" scoped>

</style>
